import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { DRHP_JOURNEY_STEPS } from '../../data/upcomingIposData';

const DEFAULT_NOTE = (
  <>
    <strong className="font-bold text-violet-900">Confidential pre-filings:</strong> companies using SEBI&apos;s
    confidential route keep their draft documents private until they formally decide to proceed with the IPO, so early
    business plans aren&apos;t exposed prematurely.
  </>
);

export const DrhpJourneySection = ({
  title = 'Understanding the SEBI DRHP Approval Journey',
  intro = "Before an IPO opens for subscription on BSE & NSE, it goes through a mandatory multi-stage vetting process governed by SEBI's ICDR Regulations.",
  steps = DRHP_JOURNEY_STEPS,
  note = DEFAULT_NOTE,
}) => (
  <section aria-labelledby="drhp-journey-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-5 sm:p-7">
    <p className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider text-[#008080]">
      <ShieldCheck className="w-3.5 h-3.5" />
      Regulatory Knowledge Base
    </p>
    <h2 id="drhp-journey-heading" className="mt-1 text-xl sm:text-2xl font-extrabold text-slate-900 tracking-tight">
      {title}
    </h2>
    <p className="mt-1 text-xs sm:text-sm text-slate-500 max-w-3xl">{intro}</p>

    <ol className="mt-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {steps.map((step, index) => (
        <li
          key={step.title}
          className={`rounded-2xl border p-4 sm:p-5 ${
            step.highlight ? 'border-emerald-300 bg-emerald-50/60 ring-1 ring-emerald-200' : 'border-slate-200 bg-white'
          }`}
        >
          <span
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-extrabold ${
              step.highlight ? 'bg-emerald-500 text-white' : 'bg-slate-900 text-white'
            }`}
          >
            {index + 1}
          </span>
          <h3 className="mt-3 text-sm font-extrabold text-slate-900">{step.title}</h3>
          <p className="mt-1.5 text-xs text-slate-600 leading-relaxed">{step.body}</p>
          <span
            className={`inline-flex mt-3 px-2 py-0.5 rounded-md border text-[10px] font-bold ${
              step.highlight ? 'border-emerald-200 bg-white text-emerald-700' : 'border-slate-200 bg-slate-50 text-slate-600'
            }`}
          >
            {step.tag}
          </span>
        </li>
      ))}
    </ol>

    {note && (
      <p className="mt-5 flex items-start gap-2 rounded-xl border border-violet-200 bg-violet-50/70 px-4 py-3 text-xs text-violet-900/80 leading-relaxed">
        <Lock className="w-4 h-4 flex-shrink-0 text-violet-600 mt-px" />
        <span>{note}</span>
      </p>
    )}
  </section>
);

export default DrhpJourneySection;
